import _ from 'lodash';
import { Action, createReducer, on } from '@ngrx/store';
import * as DialogActions from './dialog.actions';
import { noop } from 'rxjs';

export const dialogFeatureKey = 'dialog';

export interface State {
  name: string;
  options: any;
  initialState: any;
}

export const initialState: State = {
  name: null,
  options: {},
  initialState: {}
};


export const reducer = createReducer(
  initialState,

  on(DialogActions.openDialog, (state, action) => {
    const { payload } = action;
    const initialState = _.get(payload, 'initialState', {})
    initialState.callback = initialState.callback instanceof Function ? initialState.callback: noop;
    return {
      ...state,
      name: payload.name,
      options: _.get(payload, 'options', {}),
      initialState
    };
  }),
  on(DialogActions.closeDialog, state => {
    return {
      ...state,
      name: null,
      options: {},
      initialState: {}
    };
  }),
);

